import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from 'src/app/shared/services/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class ExportacaoService {
  constructor(private _requestService: RequestService) {}

  authorization(data) {
    let header = {
      'Content-Type': 'application/json',
    };
    return this._requestService.requestMethod(
      `api/authorization/api/Authorization/Login`,
      'POST',
      true,
      data,
      header
    );
  }

  dadosUsuario(companyID, restrictionKey, userID) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };
    return this._requestService.requestMethod(
      `user/api/User/Get/${userID}`,
      'GET',
      true,
      null,
      header
    );
  }

  infoExportacao(IsPartner, typeId) {
    return this._requestService.request(
      `Export/Excel/ListHistoryDate/ReportWorksByLastExportDate?IsPartner=${IsPartner}&ClientTypeID=${typeId}`,
      'GET',
      true
    );
  }

  downloadExportDate(
    LoginID,
    IsPartner,
    ExportDate,
    ClientTypeID
  ): Observable<Blob> {
    return this._requestService.request(
      `Export/Excel/ReportWorksByLastExportDate?LoginID=${LoginID}&IsPartner=${IsPartner}&ExportDate=${ExportDate}&ClientTypeID=${ClientTypeID}`,
      'GET',
      true,
      null,
      { responseType: 'blob' }
    );
  }

  downloadExport(LoginID, IsPartner, ClientTypeID): Observable<Blob> {
    return this._requestService.request(
      `Export/Excel/ReportWorksByLastExportDate?LoginID=${LoginID}&IsPartner=${IsPartner}&ClientTypeID=${ClientTypeID}`,
      'GET',
      true,
      null,
      { responseType: 'blob' }
    );
  }
}
